import { defineCustomElement } from 'vue'
// import basicCarouselWrapper from "@/components/entrypoints/build/WrapperBasicCarousel.ce.vue"
import basicCarouselWrapper from "@/components/entrypoints/build/WrapperBasicCarouselFlicking.ce.vue"
import categoryCarouselWrapper from "@/components/entrypoints/build/WrapperCategoryCarousel.ce.vue"
import MainMenuWrapper from "@/components/entrypoints/build/WrapperMainMenu.ce.vue"
import WrapperBookItems from "@/components/entrypoints/build/WrapperBookItems.ce.vue"
import WrapperSearchInput from '@/components/entrypoints/build/WrapperSearchInput.ce.vue'


const basicCarouselWrapperEl = defineCustomElement(basicCarouselWrapper)
const categoryCarouselWrapperEl = defineCustomElement(categoryCarouselWrapper)
const mainMenutWrapperEl = defineCustomElement(MainMenuWrapper)
const bookItemsWrapperEl = defineCustomElement(WrapperBookItems)
const searchInputWrapperEl = defineCustomElement(WrapperSearchInput)

customElements.define('basic-carousel', basicCarouselWrapperEl)
customElements.define('category-carousel', categoryCarouselWrapperEl)
customElements.define('main-menu', mainMenutWrapperEl)
customElements.define('book-items', bookItemsWrapperEl)
customElements.define('search-input', searchInputWrapperEl)


async function loadAsyncModule() {
    try {
      const module = await import('./shadow-html')
      console.log('Module shadow-html:', module)
    } catch (error) {
      console.error('Error loading module: shadow-html', error)
    }
}
  
loadAsyncModule()